/*
 * Карточка черновика консьержа (макет до `1adc427`, `Prototype.dc.html:1562`). Числа карточки и
 * отметки — оттуда посимвольно; перенос шапки и строка отказа — наши, в макете их нет. Анимации
 * появления нет: в панели чата макета их нет ни одной (проверено грепом ещё в задаче 9), поэтому и
 * `opacity` у заблокированных кнопок ниже — обычное свойство, перебивать его нечем.
 */
.root {
  margin: 2px 4px 0;
  padding: 12px 14px;
  border: 1px solid color-mix(in oklch, var(--accent) 34%, transparent);
  border-radius: 13px;
  background: color-mix(in oklch, var(--accent) 7%, var(--tint-on));
}

.head {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px 8px;
  margin-bottom: 8px;
}

.tile {
  display: grid;
  flex-shrink: 0;
  place-items: center;
  width: 22px;
  height: 22px;
  border-radius: 6px;
  background: var(--accent);
  color: var(--on-accent);
}

.title {
  font-size: 12px;
  font-weight: 600;
  color: var(--accent);
  white-space: nowrap;
}

/*
 * `safetyLabel` с сервера. Прижат вправо — так в макете; где рядом с заголовком места нет (панель
 * чата в карточке брони), уходит строкой ниже, а не сжимает заголовок в три строки. Длину текста
 * сервер не обещает, поэтому он переносится, а не режется.
 */
.safety {
  margin-left: auto;
  font-family: 'JetBrains Mono Variable', monospace;
  font-size: 10px;
  color: var(--ink-4);
  text-align: right;
}

/* Сам текст черновика — на `--panel`, то есть светлее подложки карточки. Так в макете. */
.text {
  padding: 9px 12px;
  border: 1px solid var(--line-2);
  border-radius: 10px;
  background: var(--panel);
  color: var(--ink);
  font-size: 13px;
  line-height: 1.45;
  /* Ответ консьержа — сырой текст: переносы строк в нём настоящие, а длинная ссылка без пробелов
     иначе вылезла бы за карточку. Тот же случай, что у пузыря сообщения. */
  white-space: pre-wrap;
  overflow-wrap: break-word;
}

.actions {
  display: flex;
  gap: 8px;
  margin-top: 10px;
}

.primary {
  height: 30px;
  padding: 0 14px;
  border: 0;
  border-radius: 8px;
  background: var(--accent);
  color: var(--on-accent);
  font: inherit;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}

.secondary {
  height: 30px;
  padding: 0 13px;
  border: 1px solid var(--line);
  border-radius: 8px;
  background: var(--panel);
  color: var(--ink);
  font: inherit;
  font-size: 12px;
  font-weight: 550;
  cursor: pointer;
}

/* «Отклонить» — тот же бокс, что «Править», но приглушённым текстом. Так в макете. */
.dismiss {
  color: var(--ink-3);
}

/*
 * Заблокированы, пока летит запрос. Приглушение — язык уже принятого в проекте заблокированного
 * состояния (`shared/ui/icon-button`, оттуда же его взяла пара «пред/след» в шапке карточки).
 * Заливкой `--sunk`, как у «Создать бронь», их гасить нельзя: у «Править» и «Отклонить» фон
 * `--panel` и своя рамка — они не первичные, и заливка сделала бы их похожими на выключенную
 * первичную кнопку.
 */
.primary:disabled,
.secondary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/*
 * Отказ «Отправить» — в карточке под кнопками, а если карточки уже нет, на её месте. Тон в фоне,
 * текст чернилами — как у отказов в окнах брони: цветной `--st-cancel` текстом не берёт AA.
 */
.refusal {
  margin: 2px 4px 0;
  padding: 8px 10px;
  border-radius: 8px;
  background: color-mix(in oklch, var(--st-cancel) 10%, var(--tint-on));
  font-size: 11.5px;
  line-height: 1.45;
  color: var(--ink-2);
}

.root .refusal {
  margin: 10px 0 0;
}

/* Отметка «Черновик консьержа отправлен» (там же, строка 1566) — вместо карточки, после успеха. */
.sent {
  display: inline-flex;
  align-self: center;
  align-items: center;
  gap: 6px;
  margin: 2px 0;
  font-size: 11px;
  font-weight: 600;
  color: var(--st-in);
}
